export default "__VITE_ASSET__Rniu7Ysp__"